import React, { Component } from "react";

const FullColorHorizontalLight = (
  <svg
    className="logo-svg"
    width="667"
    height="187"
    viewBox="0 0 667 187"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M350.436 145.26V44L323.107 44V145.26H350.436ZM372.026 77.7535L352.076 114.207L376.672 145.26H410.228L381.466 112.992L401.689 77.7535L372.026 77.7535Z"
      fill="#1E075F"
    />
    <path
      d="M537.146 77.7535V60.7417L528.264 60.7417C518.836 60.7417 514.19 66.1423 513.233 78.9686C507.631 77.2134 500.252 76.4033 490.823 76.4033C462.947 76.4033 451.469 83.8291 451.469 101.516C451.469 114.342 457.481 121.633 471.009 124.738C457.345 127.979 450.513 133.649 450.513 141.885C450.513 148.906 455.842 153.766 464.587 153.766H503.121C508.451 153.766 511.183 154.981 511.183 157.412C511.183 160.787 505.308 162.407 493.419 162.407C481.531 162.407 474.152 161.192 471.146 158.762C470.463 158.087 470.19 157.682 470.19 157.682L446.55 162.947L447.096 164.702C447.78 167.268 451.332 170.913 457.208 174.153C463.084 177.529 475.519 180.364 491.233 180.364C520.749 180.364 534.413 171.858 534.413 152.551C533.867 141.075 530.041 136.079 523.482 134.459C518.699 132.974 516.923 133.109 512.003 133.109H482.761C480.438 133.109 479.345 132.299 479.345 130.814C479.345 127.979 483.171 126.628 490.823 126.628C518.699 126.628 530.177 119.203 530.177 101.516C530.177 92.1999 526.624 85.4493 519.655 81.5339C521.295 78.9686 523.755 77.7535 526.898 77.7535H537.146ZM481.395 108.537C479.618 107.186 478.798 104.891 478.798 101.516C478.798 98.1406 479.618 95.8453 481.395 94.6302C483.171 93.2801 486.314 92.605 490.823 92.605C495.332 92.605 498.339 93.2801 500.115 94.6302C501.892 95.8453 502.848 98.1406 502.848 101.516C502.848 104.891 501.892 107.186 500.115 108.537C498.339 109.752 495.332 110.427 490.823 110.427C486.314 110.427 483.171 109.752 481.395 108.537Z"
      fill="#1E075F"
    />
    <path
      d="M597.895 88.9596C592.839 80.5887 583.82 76.4033 571.112 76.4033C551.299 76.4033 541.46 88.1495 541.46 111.507C541.46 135.404 551.982 146.611 570.566 146.611C583.001 146.611 591.746 142.425 596.665 134.054L598.463 145.26H623.994V77.7535L599.398 77.7535L597.895 88.9596ZM582.864 126.358C573.435 126.358 568.789 121.363 568.789 111.507C568.789 101.651 573.435 96.6554 582.864 96.6554C590.653 96.6554 594.069 100.031 595.572 104.081C596.665 107.186 596.665 108.807 596.665 111.912C596.665 115.557 596.392 117.583 594.752 120.958C593.249 124.333 589.013 126.358 582.864 126.358Z"
      fill="#1E075F"
    />
    <rect x="413.685" y="77" width="26.4" height="68.2" fill="#1E075F" />
    <rect x="279.485" y="77" width="26.4" height="68.2" fill="#1E075F" />
    <rect x="640.285" y="77" width="26.4" height="68.2" fill="#1E075F" />
    <rect x="413.685" y="44" width="26.4" height="22" fill="#1E075F" />
    <rect x="279.485" y="44" width="26.4" height="22" fill="#1E075F" />
    <rect x="640.285" y="44" width="26.4" height="22" fill="#1E075F" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M178.85 112.675V8.14885L126.587 60.412L178.85 112.675Z"
      fill="#EF4A42"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.466 126.587L118.44 68.5613L60.4146 126.587L118.44 184.612L176.466 126.587Z"
      fill="#824EF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.2631 134.737L0 187H104.526L52.2631 134.737Z"
      fill="#364EED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.501 112.675L46.501 66.1744L0.000244141 66.1744L46.501 112.675Z"
      fill="#1FA089"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.288 60.4132L58.025 8.1501L58.025 112.676L110.288 60.4132Z"
      fill="#99DBEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M235.601 0L190.377 0L190.377 45.2237L235.601 0Z"
      fill="#F8B03B"
    />
  </svg>
);

const FullColorHorizontalDark = (
  <svg
    className="logo-svg"
    width="667"
    height="187"
    viewBox="0 0 667 187"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M350.436 145.26V44L323.107 44V145.26H350.436ZM372.026 77.7535L352.076 114.207L376.672 145.26H410.228L381.466 112.992L401.689 77.7535L372.026 77.7535Z"
      fill="white"
    />
    <path
      d="M537.146 77.7535V60.7417L528.264 60.7417C518.836 60.7417 514.19 66.1423 513.233 78.9686C507.631 77.2134 500.252 76.4033 490.823 76.4033C462.947 76.4033 451.469 83.8291 451.469 101.516C451.469 114.342 457.481 121.633 471.009 124.738C457.345 127.979 450.513 133.649 450.513 141.885C450.513 148.906 455.842 153.766 464.587 153.766H503.121C508.451 153.766 511.183 154.981 511.183 157.412C511.183 160.787 505.308 162.407 493.419 162.407C481.531 162.407 474.152 161.192 471.146 158.762C470.463 158.087 470.19 157.682 470.19 157.682L446.55 162.947L447.096 164.702C447.78 167.268 451.332 170.913 457.208 174.153C463.084 177.529 475.519 180.364 491.233 180.364C520.749 180.364 534.413 171.858 534.413 152.551C533.867 141.075 530.041 136.079 523.482 134.459C518.699 132.974 516.923 133.109 512.003 133.109H482.761C480.438 133.109 479.345 132.299 479.345 130.814C479.345 127.979 483.171 126.628 490.823 126.628C518.699 126.628 530.177 119.203 530.177 101.516C530.177 92.1999 526.624 85.4493 519.655 81.5339C521.295 78.9686 523.755 77.7535 526.898 77.7535H537.146ZM481.395 108.537C479.618 107.186 478.798 104.891 478.798 101.516C478.798 98.1406 479.618 95.8453 481.395 94.6302C483.171 93.2801 486.314 92.605 490.823 92.605C495.332 92.605 498.339 93.2801 500.115 94.6302C501.892 95.8453 502.848 98.1406 502.848 101.516C502.848 104.891 501.892 107.186 500.115 108.537C498.339 109.752 495.332 110.427 490.823 110.427C486.314 110.427 483.171 109.752 481.395 108.537Z"
      fill="white"
    />
    <path
      d="M597.895 88.9596C592.839 80.5887 583.82 76.4033 571.112 76.4033C551.299 76.4033 541.46 88.1495 541.46 111.507C541.46 135.404 551.982 146.611 570.566 146.611C583.001 146.611 591.746 142.425 596.665 134.054L598.463 145.26H623.994V77.7535L599.398 77.7535L597.895 88.9596ZM582.864 126.358C573.435 126.358 568.789 121.363 568.789 111.507C568.789 101.651 573.435 96.6554 582.864 96.6554C590.653 96.6554 594.069 100.031 595.572 104.081C596.665 107.186 596.665 108.807 596.665 111.912C596.665 115.557 596.392 117.583 594.752 120.958C593.249 124.333 589.013 126.358 582.864 126.358Z"
      fill="white"
    />
    <rect x="413.685" y="77" width="26.4" height="68.2" fill="white" />
    <rect x="279.485" y="77" width="26.4" height="68.2" fill="white" />
    <rect x="640.285" y="77" width="26.4" height="68.2" fill="white" />
    <rect x="413.685" y="44" width="26.4" height="22" fill="white" />
    <rect x="279.485" y="44" width="26.4" height="22" fill="white" />
    <rect x="640.285" y="44" width="26.4" height="22" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M178.85 112.675V8.14886L126.587 60.412L178.85 112.675Z"
      fill="#EF4A42"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M176.466 126.587L118.44 68.5613L60.4146 126.587L118.44 184.612L176.466 126.587Z"
      fill="#824EF0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.2631 134.737L0 187H104.526L52.2631 134.737Z"
      fill="#364EED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.501 112.675L46.501 66.1744L0.000244141 66.1744L46.501 112.675Z"
      fill="#1FA089"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.288 60.4132L58.025 8.1501L58.025 112.676L110.288 60.4132Z"
      fill="#99DBEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M235.601 0L190.377 0L190.377 45.2237L235.601 0Z"
      fill="#F8B03B"
    />
  </svg>
);

interface Props {
  isDarkMode: boolean;
}

interface State {}

class Logo extends Component<Props, State> {
  state = {};
  render() {
    var { isDarkMode } = this.props;
    return (
      <a className={isDarkMode ? "logo dark" : "logo"} href="/overview">
        {isDarkMode ? FullColorHorizontalDark : FullColorHorizontalLight}
        {/* <span className="logo-txt-subtitle">DOCS</span> */}
      </a>
    );
  }
}

export default Logo;
